<app-page-header
  [title]="'Detalle Noticia'"
  [breadcrumbs]="breadcrumbs"
  [backgroundImage]="'headers/Noticias.png'"
></app-page-header>
<section class="w-full h-auto 
  py-10 md:py-16 lg:py-20 xl:py-24 2xl:py-28
  px-5 3xl:px-[295px] 2xl:px-[120px] xl:px-[45px] md:px-28
">
  @if (isLoading()) {
    <div class="flex justify-center items-center h-[400px]">
      <div class="w-12 h-12 border-4 border-secondary border-t-transparent rounded-full animate-spin"></div>
    </div>
  } @else if (post()) {
    <div class="grid grid-cols-1 md:grid-cols-10">
      <div class="col-span-7">
        <!-- post details container -->
        <div class="pe-0 md:pe-[25px]">

          <!-- single post -->
          <article
            class="tj-single__post mb-[50px] post-80 post type-post status-publish format-standard has-post-thumbnail hentry category-branding category-business category-consuting category-marketing tag-business tag-design tag-marketing"
          >
            <!-- post thumbnail -->
            @if (post().imageUrl) {
              <div class="tj-post-thumb hover:shine mb-[25px]">
                <img
                  fetchpriority="high"
                  width="870"
                  height="498"
                  [src]="post().imageUrl"
                  class="img-responsive wp-post-image w-full h-auto object-cover"
                  [alt]="post().title"
                  decoding="async"
                >
              </div>
            }
            <div class="tj-post__content">
              <!-- entry title -->
              <h3 class="font-heading text-2xl text-heading-primary mb-[25px]">{{ post().title }}</h3>
              <!-- entry-meta -->

              <div class="blog-category-two mb-6 mt-6 p-5 grid grid-cols-1 md:grid-cols-3">
                <div class="category-item">
                  <div class="cate-images">
                    <img
                      src="https://secure.gravatar.com/avatar/5763612024bbc7fbf6b9e770625081d73d646f203a25f559e3c820ae8be4fe5d?s=96&amp;d=mm&amp;r=g"
                      alt="Images"
                    >
                  </div>
                  <div class="cate-text">
                    <span class="degination">Autor</span>
                    <h6 class="title font-heading text-heading-primary font-semibold"><a href="#">{{ post().author || '-' }}</a>
                    </h6>
                  </div>
                </div>
                <div class="category-item">
                  <div class="cate-icons">
                    <i class="material-symbols-outlined">calendar_month</i>
                  </div>
                  <div class="cate-text">
                    <span class="degination">Fecha</span>
                    <h6 class="text font-heading text-heading-primary font-semibold">{{ post().date | date:'mediumDate' }}</h6>
                  </div>
                </div>
                <div class="category-item">
                  <div class="cate-icons">
                    <i class="material-symbols-outlined">newspaper</i>
                  </div>
                  <div class="cate-text">
                    <span class="degination">Fuente</span>
                    <h6 class="text font-heading text-heading-primary font-semibold">{{ post().category || '-' }}</h6>
                  </div>
                </div>
              </div>
              <!-- entry content -->
              <div class="tj-entry__content tj-entry-content text-text-body">
                <div [innerHTML]="post().description"></div>
              </div>

              <div class="tj-entry__content tj-entry-content text-text-body pt-2">
                <div class="wrap-break-word text-justify rich-text" [innerHTML]="post().content"></div>
              </div>

              <!-- document -->
              @if (post().document) {
                <div class="mt-[30px] mb-[30px]">
                  <div class="group flex items-center flex-wrap gap-[15px] p-5 border border-border-2 bg-theme-bg-2 transition-all duration-300 ease-in-out hover:border-secondary hover:shadow-[0_4px_6px_rgba(0,0,0,0.08)] rounded-lg md:flex-nowrap md:gap-5 md:p-[25px]">
                    <div class="relative flex items-center justify-center w-[60px] h-[60px] min-w-[60px] md:w-[70px] md:h-[70px] md:min-w-[70px] bg-primary/10 rounded-xl transition-all duration-300 ease-in-out group-hover:bg-secondary/15 group-hover:scale-105">
                      <i class="material-symbols-outlined text-[30px]! md:text-[36px] text-primary transition-all duration-300 ease-in-out group-hover:scale-110">description</i>
                      <span class="absolute bottom-[5px] right-[5px] text-[10px] font-bold text-white bg-secondary px-1.5 py-0.5 rounded uppercase leading-none">{{ post().document.extension || 'FILE' }}</span>
                    </div>
                    <div class="flex-1 min-w-0 w-full order-2 md:order-0 md:w-auto">
                      <h6 class="text-[15px] md:text-base font-semibold text-heading-primary mb-2 leading-snug overflow-visible whitespace-normal md:overflow-hidden md:text-ellipsis md:whitespace-nowrap">{{ post().document.name }}</h6>
                      <div class="flex items-center gap-2 text-sm text-text-body">
                        <span class="font-medium text-secondary">{{ post().document.extension?.toUpperCase() || 'Archivo' }}</span>
                        @if (post().document.size) {
                          <span class="text-border-2">•</span>
                          <span class="font-normal">{{ formatFileSize(post().document.size) }}</span>
                        }
                      </div>
                    </div>
                    <a href="{{ post().document.url }}" target="_blank" download class="group/btn inline-flex items-center justify-center gap-2 px-6 py-3.5 md:py-3 bg-secondary text-white rounded-md font-semibold text-sm no-underline transition-all duration-300 ease-in-out whitespace-nowrap hover:bg-secondary/85 hover:-translate-y-0.5 hover:shadow-[0_4px_8px_rgba(0,0,0,0.15)] active:translate-y-0 w-full order-3 md:w-auto md:order-0">
                      <i class="material-symbols-outlined text-[20px] transition-transform duration-300 ease-in-out group-hover/btn:translate-y-0.5">download</i>
                      <span>Descargar</span>
                    </a>
                  </div>
                </div>
              }
            </div>
          </article>
          <!-- !single post -->

          <!-- post tag & share -->
          <div class="tj-post-details_tags_share ">
            <!-- post tags -->
            <div class="tj-tags tagcloud">
              <span class="tag__title">Tags : </span>
              @if (post().tags) {
                @for (tag of post().tags; track $index) {
                  <a [routerLink]="['/news/search', tag.title]" rel="tag" class="lowercase text-xs!">{{ tag.title }}</a>
                }
              }

            </div>
            <div class="tj-socials_share">
              <span class="tag__title">Compartir:</span>
              <a
                href="https://www.facebook.com/sharer/sharer.php?u={{ urlPost() }}"
                target="_blank"
                class="facebook"
                title="Share this on Facebook"
                (click)="handleSharedNews()"
              >
                <i class="fa-brands fa-facebook-f"></i>
              </a>
              <a
                href="https://twitter.com/intent/tweet?text={{ post().title }}&url={{ urlPost() }}"
                class="twitter"
                title="Share this on Twitter"
                target="_blank"
                (click)="handleSharedNews()"
              >
                <i class="fab fa-x-twitter"></i>
              </a>
              <a
                href="https://www.linkedin.com/shareArticle?mini=true&url={{ urlPost() }}"
                class="linkedin"
                title="Share this on Linkedin"
                target="_blank"
                (click)="handleSharedNews()"
              >
                <i class="fa-brands fa-linkedin-in"></i>
              </a>
            </div>
          </div>

          <div class="tj-post__navigation">
            <!-- previous post -->
            <div class="tj-nav__post previous">
              <div class="tj-nav-post__nav prev_post">
                <button
                  (click)="goToPrevPost()"
                  [disabled]="!prevPost() || !prevPost().id"
                  class="disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <span class="icon"><i class="material-symbols-outlined">arrow_left_alt</i></span>
                  <span class="hidden md:block">Anterior</span> 
                </button>
              </div>
            </div>
            <div class="tj-nav-post__grid">
              <i class="material-symbols-outlined text-4xl!">newsstand</i>
            </div>
            <!-- next post -->
            <div class="tj-nav__post next">
              <div class="tj-nav-post__nav next_post">
                <button 
                  (click)="goToNextPost()"
                  [disabled]="!nextPost() || !nextPost().id"
                  class="disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <span class="hidden md:block">Siguiente</span>
                  <span class="icon"><i class="material-symbols-outlined">arrow_right_alt</i></span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- !post details container -->
      </div>
      <!-- sidebar -->
      <div class="col-span-3">
        <app-news-sidebar></app-news-sidebar>
      </div> <!-- !sidebar -->
    </div>
  }
</section>